import React from 'react';
import { SeoStrip } from './components/SeoStrip';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { EastEndWay } from './components/EastEndWay';
import { Services } from './components/Services';
import { AppointmentRequest } from './components/AppointmentRequest';
import { Reviews } from './components/Reviews';
import { ShopExperience } from './components/ShopExperience';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="2mjpx9irg3khe">
      <SeoStrip data-id="element-1" data-mp="31ayplzmqfjy8" />
      <Header data-id="element-2" data-mp="31bi9vmzuukff" />
      <main data-id="element-3" data-mp="31c1gw8nyvoeo">
        <Hero data-id="element-4" data-mp="31ctetq51dy84" />
        <TrustStrip data-id="element-5" data-mp="2wk0b95lb0vxm" />
        <EastEndWay data-id="element-6" data-mp="2wjgq7g0cxrfd" />
        <Services data-id="element-7" data-mp="2wj8cxn0bok3n" />
        <AppointmentRequest data-id="element-8" data-mp="2wip5x1c7ng4e" />
        <Reviews data-id="element-9" data-mp="28ufqch5lbolp" />
        <ShopExperience data-id="element-10" data-mp="28tw5osok2m3z" />
      </main>
      <SiteFooter data-id="element-11" data-mp="28suu8n3mnxlq" />
    </div>;
}